import { mediaQueries } from '@goeuro/app/client/frontend-components/src/style-values/mediaQueries';
import { breakpoints } from '@goeuro/app/client/frontend-components/src/helpers/breakpoints';

export default {
  ...mediaQueries,
  // Constants below are legacy media queries, that where used before.
  // For new components the preferable way is to use mobile first approach and use 'tabletAndLarger' and 'desktop' media queries for larger screens.
  mobileOnly: `@media (max-width: ${breakpoints.TABLET}px)`,
  tabletAndMobileOnly: `@media (max-width: ${breakpoints.DESKTOP}px)`,
};
